import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

export type AuthStatus = 'loading' | 'authed' | 'unauth';

/**
 * Lightweight binary auth check. Returns 'loading' until the first
 * `getSession()` resolves, then flips to 'authed' / 'unauth'. Subscribes to
 * `onAuthStateChange` so sign-out from another tab or token expiry flips the
 * status without a reload. Does NOT load the profile or memberships —
 * `useShellSession` still owns that downstream of `RequireAuth`.
 */
export function useAuthStatus(): AuthStatus {
  const [status, setStatus] = useState<AuthStatus>('loading');

  useEffect(() => {
    let cancelled = false;

    supabase.auth.getSession().then(({ data }) => {
      if (cancelled) return;
      setStatus(data.session ? 'authed' : 'unauth');
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (cancelled) return;
      setStatus(session ? 'authed' : 'unauth');
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);

  return status;
}
